import styled from 'styled-components';

import { primaryColor } from 'views/services/color-scheme';
import backgroundImage from './assets/background-image.gif';

export const Background = styled.div`
  background-image: url(${backgroundImage});
  background-position: center top;
  height: 280px;
`;

export const Heading = styled.div`
  position: absolute;
  left: 47px;
  top: 42px;
`;

export const Information = styled.div`
  a {
    color: ${primaryColor};
    text-decoration: underline;
    &:hover {
      opacity: 0.75;
    }
  }
  & > h2 {
    position: absolute;
    left: 62px;
    top: 93px;
  }
  & > p {
    position: absolute;
    left: 44px;
    top: 139px;
  }
  & > table {
    position: absolute;
    left: 59px;
    top: 170px;
    & > tbody {
      & > tr {
        & > th {
          padding: 5px 15px 0 0;
          font-weight: normal;
        }
        & > td {
          padding: 5px 0 0 0;
          font-weight: normal;
        }
      }
    }
  }
`;
